"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Table = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Table = ({
  className,
  variant,
  cellVariants,
  tableHover,
  tableScroller,
  ...rest
}) => {
  let baseClass = "table";
  let tableClasses = (0, _classnames.default)(className, `${baseClass}`, `${baseClass}-${variant}`, cellVariants ? `${cellVariants}-cell` : "", tableHover ? `${baseClass}-hover` : "");
  let tableWrapper = (0, _classnames.default)(tableScroller ? `${baseClass}-scroller ${tableScroller}-${baseClass}-scroller` : `${baseClass}-scroller`); // let remixIconClasses = classNames(icon, "icon","sp-ml--8");

  if (variant === "bounded-fixed") {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "table-wrapper"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: tableWrapper
    }, /*#__PURE__*/_react.default.createElement("table", _extends({
      className: tableClasses
    }, rest))));
  } else {
    return /*#__PURE__*/_react.default.createElement("table", _extends({
      className: tableClasses
    }, rest));
  }
};

exports.Table = Table;
Table.defaultProps = {
  variant: "",
  cellVariants: "default",
  tableHover: false,
  tableScroller: ""
};
Table.propTypes = {
  className: _propTypes.default.string,
  variant: _propTypes.default.oneOf(_utils.enums.tableVariants),
  cellVariants: _propTypes.default.oneOf(_utils.enums.tableCellVariants),
  tableHover: _propTypes.default.bool,
  tableScroller: _propTypes.default.oneOf(_utils.enums.tableScrollerVariants)
};
var _default = Table;
exports.default = _default;